(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-experience-picker"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pa-experience-picker'))customElements.define('pa-experience-picker',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();
      const signal=this.abort.signal,dialog=this.querySelector('dialog'),frame=this.querySelector('iframe'),loading=this.querySelector('[data-loading]');
      const choices=[...this.querySelectorAll('[data-experience-url]')];
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const finePointer=matchMedia('(hover: hover) and (pointer: fine)');
      choices.forEach(button=>{
        let bounds;
        button.addEventListener('pointerenter',()=>{bounds=button.getBoundingClientRect();},{signal});
        button.addEventListener('pointermove',event=>{
          if(motion.matches||!finePointer.matches||!bounds)return;
          button.style.setProperty('--tilt-x',`${(0.5-(event.clientY-bounds.top)/bounds.height)*2}deg`);
          button.style.setProperty('--tilt-y',`${((event.clientX-bounds.left)/bounds.width-0.5)*2}deg`);
        },{signal});
        button.addEventListener('pointerleave',()=>{bounds=null;button.style.removeProperty('--tilt-x');button.style.removeProperty('--tilt-y');},{signal});
      });
      const reveal=[this.querySelector('.pa-experiences__intro'),...choices];
      if(!motion.matches&&'IntersectionObserver' in window){
        this.setAttribute('data-motion','');
        this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.setAttribute('data-revealed','');this.revealObserver.unobserve(entry.target);}}),{threshold:.15});
        reveal.forEach(node=>{node.setAttribute('data-reveal','');this.revealObserver.observe(node);});
        this.addEventListener('focusin',()=>reveal.forEach(node=>node.setAttribute('data-revealed','')),{signal});
      }
      let opener,oldOverflow,closing=false,loadVersion=0,returnY=0,loadTimer,activeChoice;
      const retry=this.querySelector('[data-retry]'),message=this.querySelector('[data-loading-message]'),initialMessage=message.textContent;
      const failed=()=>{clearTimeout(loadTimer);loading.hidden=false;retry.hidden=false;loading.classList.add('is-failed');message.textContent=retry.dataset.error;};
      const close=()=>{
        if(closing||!dialog.open)return;
        if(motion.matches){dialog.close();return;}
        closing=true;
        this.exitAnimation=dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(12px)'}],{duration:220,easing:'ease-in',fill:'forwards'});
        this.exitAnimation.finished.then(()=>{dialog.close();this.exitAnimation.cancel();closing=false;}).catch(()=>{closing=false;});
      };
      const show=(button)=>{
        if(closing||!button.dataset.experienceUrl)return;
        activeChoice=button;clearTimeout(loadTimer);retry.hidden=true;loading.classList.remove('is-failed');message.textContent=initialMessage;
        if(!dialog.open){opener=button;returnY=scrollY;oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}
        this.querySelector('[data-panel-title]').textContent=button.dataset.title;
        frame.title=button.dataset.title;
        loading.hidden=false;
        frame.removeAttribute('data-loaded');
        const version=++loadVersion,url=new URL(button.dataset.experienceUrl,location.href);
        loadTimer=setTimeout(()=>{if(version===loadVersion&&dialog.open)failed();},15000);
        if(url.origin!==location.origin){location.assign(url.href);return;}
        frame.removeAttribute('srcdoc');
        fetch(url.href,{signal}).then(response=>{if(!response.ok)throw Error('Experience unavailable');return response.text();}).then(html=>{
          if(version!==loadVersion||!dialog.open)return;
          const documentHTML=new DOMParser().parseFromString(html,'text/html');
          if(!documentHTML.querySelector('base')){const base=documentHTML.createElement('base');base.href=url.href;documentHTML.head.prepend(base);}
          frame.srcdoc='<!doctype html>'+documentHTML.documentElement.outerHTML;
        }).catch(error=>{if(error.name!=='AbortError'&&version===loadVersion&&dialog.open)failed();});
        this.querySelectorAll('[data-switch]').forEach((b,i)=>b.setAttribute('aria-pressed',String(choices[i]===button)));
      };
      choices.forEach(button=>button.addEventListener('click',()=>show(button),{signal}));
      retry.addEventListener('click',()=>show(activeChoice),{signal});
      dialog.addEventListener('close',()=>clearTimeout(loadTimer),{signal});
      this.querySelectorAll('[data-switch]').forEach((button,i)=>button.addEventListener('click',()=>show(choices[i]),{signal}));
      this.querySelector('[data-close]').addEventListener('click',close,{signal});
      dialog.addEventListener('cancel',event=>{event.preventDefault();close();},{signal});
      dialog.addEventListener('close',()=>{loadVersion++;frame.removeAttribute('srcdoc');frame.removeAttribute('src');document.documentElement.style.overflow=oldOverflow||'';opener?.focus({preventScroll:true});window.scrollTo({top:returnY,behavior:'instant'});},{signal});
      frame.addEventListener('load',()=>{
        if(!dialog.open||!frame.hasAttribute('srcdoc'))return;
        clearTimeout(loadTimer);loading.hidden=true;
        frame.setAttribute('data-loaded','');
        try{frame.contentDocument.addEventListener('keydown',event=>{if(event.key==='Escape'&&!event.defaultPrevented){event.preventDefault();close();}},{signal});}catch(_){}
      },{signal});
      this.closePanel=()=>{if(dialog.open)dialog.close();};
    }
    disconnectedCallback(){this.exitAnimation?.cancel();this.revealObserver?.disconnect();this.closePanel?.();this.abort?.abort();this.abort=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-flythrough"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-pa-fly]');
    if (!roots.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    roots.forEach(function (root) {
      var video = root.querySelector('[data-pa-fly-video]');
      var cues = Array.prototype.slice.call(root.querySelectorAll('[data-pa-fly-cue]'));
      var bar = root.querySelector('[data-pa-fly-progress]');
      var marker = root.querySelector('[data-pa-fly-marker]');
      var readout = root.querySelector('[data-pa-fly-read]');
      var track = root.querySelector('.pa-fly__scale-track');
      var exit = root.querySelector('[data-pa-fly-exit]');

      // Back to the top of the page, not forward past the section: leaving
      // a full-screen piece should return you to where you came in.
      if (exit) {
        exit.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
      if (!video || !cues.length || reduce.matches) return;

      // A touchscreen scrubs the film with the scroll, the same as a pointer.
      //
      // It did not used to. iOS will not paint a seeked frame on a video that
      // has never played, so scrubbing left a frozen first frame with copy
      // sliding over it, and phones were given an autoplaying loop instead.
      // The cure is to play the thing once: muted and playsinline autoplay is
      // permitted, so the film is started and stopped before the first seek
      // (see prime), after which currentTime paints like anywhere else.
      //
      // Autoplay is still the fallback, but it is now entered on evidence --
      // priming refused, or seeks that visibly go nowhere -- rather than
      // assumed from the pointer type.
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      var narrow = window.innerWidth < 750;
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var thrifty = !!(conn && (conn.saveData || /2g/.test(conn.effectiveType || '')));
      // Only a genuinely metered connection keeps the editorial list.
      if (thrifty) return;
      var primed = false;

      var duration = 0;
      var shown = -1;
      var running = false;
      var rendered = 0;
      var stuck = 0;
      // Damped so the picture does not twitch frame to frame, but tight enough
      // to stay tied to the scrollbar.
      var EASE = 0.12;

      var authored = parseFloat(root.getAttribute('data-duration')) || 0;
      var ranges = [];

      function buildRanges() {
        // Scale authored seconds onto the duration actually served.
        var k = authored > 0 && duration > 0 ? duration / authored : 1;
        ranges = cues.map(function (c, i) {
          var a = (parseFloat(c.getAttribute('data-in')) || 0) * k;
          var b = (parseFloat(c.getAttribute('data-out')) || 0) * k;
          // The last cue runs to the end whatever the transcode did.
          if (i === cues.length - 1) b = Math.max(b, duration + 1);
          return { in: a, out: b };
        });
      }

      function show(i) {
        if (i === shown) return;
        shown = i;
        cues.forEach(function (c, n) {
          if (n === i) { c.setAttribute('data-on', ''); c.removeAttribute('aria-hidden'); }
          else { c.removeAttribute('data-on'); c.setAttribute('aria-hidden', 'true'); }
        });
      }

      // Start the film and stop it again at the first frame that lands. That
      // one playback is what earns the right to seek on iOS; everywhere else
      // it costs a frame nobody sees. Muted autoplay can still be refused, so
      // a first touch is kept in reserve as a second chance at it.
      function prime() {
        if (primed) return;
        var pr;
        try { pr = video.play(); } catch (e) { return; }
        if (!pr || !pr.then) { primed = true; return; }
        pr.then(function () {
          video.pause();
          try { video.currentTime = rendered; } catch (e) { /* not seekable yet */ }
          primed = true;
        }).catch(function () {
          primed = false;
        });
      }

      // Scroll distance the pin is worth. A thumb travels less per gesture
      // than a wheel does, so six screens of scroll for one section -- fine on
      // a desktop -- is a long drag on a phone. The phone gets four.
      function screens() {
        var per = narrow ? 7 : 5;
        var floor = narrow ? 3 : 4;
        return Math.max(floor, Math.round(duration / per));
      }

      // The film refused to be scrubbed. Rather than dropping to the static
      // list, fall back to what phones used to get: one screen, playing.
      function playback() {
        if (root.hasAttribute('data-play')) return;
        running = false;
        root.style.height = '';
        root.setAttribute('data-play', '');
        video.loop = true;
        var pr = video.play();
        if (pr && pr.catch) {
          pr.catch(function () {
            // Nothing will move it -- hand back the editorial list rather
            // than leaving a still frame with copy over it.
            root.removeAttribute('data-live');
            root.removeAttribute('data-play');
          });
        }
        playFrame();
      }

      function go() {
        if (!duration || !isFinite(duration)) return;
        buildRanges();
        root.setAttribute('data-live', '');

        prime();
        if (coarse) {
          window.addEventListener('touchstart', prime, { once: true, passive: true });
        }

        root.style.height = screens() * 100 + 'svh';
        frame();
      }

      function playFrame() {
        if (!root.hasAttribute('data-play')) return;
        var t = video.currentTime || 0;
        var hit = -1;
        for (var i = 0; i < ranges.length; i++) {
          if (t >= ranges[i].in && t < ranges[i].out) { hit = i; break; }
        }
        if (hit >= 0) show(hit);
        if (bar) bar.style.width = ((t / duration) * 100).toFixed(2) + '%';
        if (marker && track) {
          marker.style.transform = 'translate3d(0,' + ((t / duration) * track.clientHeight).toFixed(1) + 'px,0)';
        }
        if (readout) {
          var sec = Math.round(t);
          readout.textContent = (sec < 10 ? '0' : '') + sec;
        }
        window.requestAnimationFrame(playFrame);
      }

      function frame() {
        // Once the film has fallen back to playing itself, a later scroll must
        // not restart the scrub loop and fight the playhead for currentTime.
        if (root.hasAttribute('data-play')) { running = false; return; }

        var rect = root.getBoundingClientRect();
        var scrollable = root.offsetHeight - window.innerHeight;
        if (scrollable <= 0) { running = false; return; }

        var p = Math.min(Math.max(-rect.top / scrollable, 0), 1);
        var target = p * duration;
        rendered += (target - rendered) * EASE;
        if (Math.abs(target - rendered) < 0.01) rendered = target;

        try {
          if (Math.abs(video.currentTime - rendered) > 0.03) video.currentTime = rendered;
        } catch (e) { /* not seekable yet */ }

        // Some browsers accept a seek and never move the playhead. Only
        // judge that once the video is genuinely ready to seek, and give it
        // real time: a large file takes seconds to become seekable, and an
        // impatient check here reads as broken on a perfectly good one. A
        // device still waiting on prime() is not stuck either -- that is the
        // one case where a motionless playhead is expected.
        var ready2seek = video.readyState >= 3 && video.seekable && video.seekable.length > 0;
        if (rendered > 1 && primed && ready2seek && video.currentTime < 0.2) {
          if (!stuck) stuck = Date.now();
          else if (Date.now() - stuck > 6000) {
            playback();
            return;
          }
        } else if (stuck) {
          stuck = 0;
        }

        var hit = -1;
        for (var i = 0; i < ranges.length; i++) {
          if (rendered >= ranges[i].in && rendered < ranges[i].out) { hit = i; break; }
        }
        if (hit >= 0) show(hit);

        if (bar) bar.style.width = (p * 100).toFixed(2) + '%';

        if (marker && track) {
          marker.style.transform =
            'translate3d(0,' + (p * track.clientHeight).toFixed(1) + 'px,0)';
        }
        if (readout) {
          var sec = Math.round(rendered);
          readout.textContent = (sec < 10 ? '0' : '') + sec;
        }

        var off = rect.top > window.innerHeight || rect.bottom < 0;
        if (off && Math.abs(target - rendered) < 0.01) { running = false; return; }
        window.requestAnimationFrame(frame);
      }

      function onScroll() {
        if (running) return;
        running = true;
        window.requestAnimationFrame(frame);
      }

      function ready() {
        duration = video.duration || parseFloat(root.getAttribute('data-duration')) || 0;
        go();
      }

      video.addEventListener('loadedmetadata', ready);

      // Source is attached here, after the reduced-motion and metered-data
      // guards, so a visitor who will never see the film never downloads it.
      //
      // Scrubbing is not streaming -- the scroll can land anywhere, so the
      // whole file has to arrive. That is the argument for the phone cut:
      // 6.8 MB at 720p rather than 18 MB at 1080p, identical frame for frame
      // so one set of cue times fits either. And it is fetched only once the
      // section is within a screen and a half, so a visitor who bounces off
      // the hero pays nothing for a film they never reached.
      var src = (narrow && video.getAttribute('data-src-phone')) || video.getAttribute('data-src');

      function attach() {
        if (!src || video.src) return;
        video.preload = 'auto';
        video.src = src;
        video.load();
        if (video.readyState >= 1) ready();
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            attach();
          },
          { rootMargin: '150% 0px' }
        );
        io.observe(root);
      } else {
        attach();
      }
      video.addEventListener('error', function () { root.removeAttribute('data-live'); });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-scroll-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pa-scroll-story')) {
    customElements.define('pa-scroll-story', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.video = this.querySelector('video');
        this.seekRetries = 0;
        this.reloads = 0;
        this.chapters = [...this.querySelectorAll('[data-start]')];
        this.motion = matchMedia('(prefers-reduced-motion: reduce), (max-height: 600px)');
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); });
        };
        this.measure = () => {
          this.start = this.getBoundingClientRect().top + window.scrollY;
          this.distance = this.querySelector('footer').offsetTop - this.querySelector('.pa-scroll-story__stage').offsetHeight;
          this.schedule();
        };
        this.fallback = () => {
          clearTimeout(this.seekTimer);
          this.removeAttribute('data-active');
          this.chapters.forEach(chapter => { chapter.removeAttribute('style'); chapter.removeAttribute('aria-hidden'); chapter.inert = false; });
          this.video.pause();
        };
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.fallback();
          else if (this.video.readyState >= 2 && !this.video.error) { this.setAttribute('data-active',''); this.measure(); }
          else this.load();
        }, {signal});
        window.addEventListener('scroll', this.schedule, {passive:true, signal});
        window.addEventListener('resize', this.measure, {passive:true, signal});
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { clearTimeout(this.seekTimer); this.video.pause(); }
          else { this.seekRetries = 0; this.schedule(); }
        }, {signal});
        this.addEventListener('pointerdown', () => {
          if (this.motion.matches || !this.hasAttribute('data-active') || this.primed) return;
          this.video.muted = true;
          const play = this.video.play();
          play?.then(() => { this.primed = true; this.video.pause(); this.schedule(); }).catch(() => {});
        }, {signal});
        this.querySelector('.pa-scroll-story__skip').addEventListener('click', event => {
          if (!this.hasAttribute('data-active')) return;
          event.preventDefault();
          window.scrollTo({top:this.start + this.distance*.99,behavior:'instant'});
          this.render();
          this.querySelector('.pa-scroll-story__shop').focus({preventScroll:true});
        }, {signal});
        this.video.addEventListener('error', this.fallback, {signal});
        this.video.addEventListener('loadeddata', () => {
          if (this.motion.matches) return;
          this.setAttribute('data-active','');
          this.measure();
          const play = this.video.play();
          if (play) play.then(() => { this.primed = true; this.video.pause(); this.schedule(); }).catch(() => this.schedule());
        }, {signal});
        this.video.addEventListener('seeked', () => { clearTimeout(this.seekTimer); this.seekRetries = 0; this.schedule(); }, {signal});
        for (const event of ['canplay','progress']) this.video.addEventListener(event, this.schedule, {signal});
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, {rootMargin:'500px'});
        this.observer.observe(this);
      }
      load() {
        if (this.motion.matches || this.video.getAttribute('src')) return;
        this.video.src = this.video.dataset.src;
        this.video.preload = 'auto';
        this.video.load();
      }
      render() {
        if (!this.hasAttribute('data-active')) return;
        this.start = this.getBoundingClientRect().top + window.scrollY;
        const clamp = n => Math.max(0,Math.min(1,n));
        const progress = clamp((window.scrollY - this.start) / Math.max(1,this.distance))*1.16;
        this.style.setProperty('--story-progress',progress/1.16);
        const smooth = value => { const t = clamp(value); return t*t*(3-2*t); };
        const entrance = smooth((window.scrollY - this.start + window.innerHeight*.5)/(window.innerHeight*.9));
        this.style.setProperty('--entrance',entrance);
        this.style.setProperty('--film-reveal',.35 + entrance*.65);
        this.chapters.forEach(chapter => {
          const start = Number(chapter.dataset.start), end = Number(chapter.dataset.end);
          const final = chapter.hasAttribute('data-final');
          const visible = progress >= start && (progress < end || final);
          const opacity = visible ? Math.min(start === 0 ? entrance : smooth((progress-start)/.06), final ? 1 : smooth((end-progress)/.06)) : 0;
          chapter.style.opacity = opacity;
          chapter.style.setProperty('--reveal',opacity);
          const arrival = start === 0 ? entrance : clamp((progress-start)/.09);
          chapter.style.setProperty('--arrival',smooth(arrival));
          chapter.style.setProperty('--departure',final ? 0 : smooth((progress-(end-.055))/.055));
          chapter.style.setProperty('--heading-reveal',smooth((arrival-.12)/.65));
          chapter.style.setProperty('--body-reveal',smooth((arrival-.3)/.7));
          chapter.style.visibility = visible ? 'visible' : 'hidden';
          chapter.style.transform = `translateY(${(1-opacity)*12}px)`;
          chapter.setAttribute('aria-hidden',String(!visible));
          chapter.inert = !visible;
        });
        const time = clamp(progress) * Math.max(0,this.video.duration-.05);
        this.targetTime = time;
        this.seekToTarget();
      }
      seekToTarget(force = false) {
        const video = this.video;
        if (document.hidden || this.motion.matches || !this.isConnected || !Number.isFinite(this.targetTime) || video.readyState < 1) return;
        if (!force && (video.seeking || Math.abs(video.currentTime-this.targetTime) <= .04)) return;
        try { video.currentTime = this.targetTime; } catch (_) { this.fallback(); return; }
        clearTimeout(this.seekTimer);
        this.seekTimer = setTimeout(() => {
          if (document.hidden || this.motion.matches || !this.isConnected) return;
          if (!video.seeking && video.readyState >= 2) { this.schedule(); return; }
          if (++this.seekRetries <= 2) this.seekToTarget(true);
          else if (this.reloads++ < 1) { this.seekRetries = 0; video.load(); }
        }, 1800);
      }
      disconnectedCallback() {
        clearTimeout(this.seekTimer);
        this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-pa-statement]');
    if (!roots.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    roots.forEach(function (root) {
      var lines = Array.prototype.slice.call(root.querySelectorAll('[data-pa-statement-line]'));
      var n = lines.length;
      if (n < 2) return;

      // A screen per line, plus a little for the last one to be read before
      // the stage lets go.
      root.style.height = (n + 0.6) * 100 + 'svh';
      root.setAttribute('data-live', '');

      var TRAVEL = 5 * parseFloat(getComputedStyle(document.documentElement).fontSize || 10);
      var queued = false;

      function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
      // Expo out, as everywhere else on the homepage: quick off the mark, a
      // long quiet arrival, never past it.
      function ease(t) { return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t); }

      function paint() {
        queued = false;
        var rect = root.getBoundingClientRect();
        var run = root.offsetHeight - window.innerHeight;
        if (run <= 0) return;
        var p = clamp(-rect.top / run);
        var seg = 1 / n;

        lines.forEach(function (el, i) {
          var t = (p - i * seg) / seg; // this line's own 0..1
          var y, o;
          if (t < 0) { y = TRAVEL; o = 0; }
          else if (t < 0.35) { var a = ease(t / 0.35); y = TRAVEL * (1 - a); o = a; }
          else if (t < 0.72 || i === n - 1) { y = 0; o = 1; }
          else if (t < 1) { var b = ease((t - 0.72) / 0.28); y = -TRAVEL * b; o = 1 - b; }
          else { y = -TRAVEL; o = 0; }
          el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
          el.style.opacity = o.toFixed(3);
          if (o > 0.5) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
        });

        root.style.setProperty('--pa-statement-zoom', (1.06 - 0.06 * p).toFixed(4));
      }

      function schedule() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(paint);
      }

      paint();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
